export const updateLocalAction = (actions) => {
    return (dispatch, getState) => {
        dispatch({ type: 'LOCAL_ACTION_UPDATE', actions })
    }
}
